import React, { useState, useEffect } from "react";
import Chain from "../components/Chain";

function OptimalRoute() {
  const [value, setValue] = useState("");
  const [showchains, setShowChains] = useState(false);
  const [financialCosts, setFinancialCosts] = useState([]);
  const [totalTimeValues, setTotalTimeValues] = useState([]);
  const [envCosts, setEnvCosts] = useState([]);
  const [remove, setRemove] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    console.log("Env total cost");
  }, [envCosts]);

  const handleChange = (event) => {
    const inputValue = event.target.value;

    // Only allow positive numeric values
    if (/^\d*$/.test(inputValue)) {
      setValue(inputValue);
    }
  };

  const handleEnvCostUpdate = (chainOrder, updatedEnvCost) => {
    setEnvCosts((prevEnvCosts) => {
      const updatedCosts = [...prevEnvCosts];
      updatedCosts[chainOrder - 1] = updatedEnvCost;
      return updatedCosts;
    });
  };

  const handleFinancialCostUpdate = (chainOrder, updatedFinancialCost) => {
    setFinancialCosts((prevFinancialCosts) => {
      const updatedCosts = [...prevFinancialCosts];
      updatedCosts[chainOrder - 1] = updatedFinancialCost;
      return updatedCosts;
    });
  };

  const handleTimeValueUpdate = (chainOrder, totalTimeValue) => {
    setTotalTimeValues((prevTotalTimeValues) => {
      const updatedTotalTimeValues = [...prevTotalTimeValues];

      if (chainOrder - 1 >= updatedTotalTimeValues.length) {
        // Resize the array to accommodate the new value
        updatedTotalTimeValues.length = chainOrder;
      }

      if (typeof totalTimeValue === "number" && !isNaN(totalTimeValue)) {
        updatedTotalTimeValues[chainOrder - 1] = totalTimeValue;
      }

      return updatedTotalTimeValues;
    });
  };

  const handleButtonClick = () => {
    // Perform any necessary action when the button is clicked
    setShowChains(true);
    setFinancialCosts([]);
    setTotalTimeValues([]); // Reset totalTimeValues
    setRemove(true);
  };

  const handleClearButtonClick = () => {
    // Clear all child components
    //setShowChains(false);

    let minValueCost = Math.min(...financialCosts);
    let minIndexCost = financialCosts.indexOf(minValueCost);

    let minValueTime = Math.min(...totalTimeValues);
    let minIndexTime = totalTimeValues.indexOf(minValueTime);

    let minValueEnv = Math.min(...envCosts);
    let minIndexEnv = envCosts.indexOf(minValueEnv);

    setResult(
      <div
        style={{
          marginLeft: "45px",
          marginTop: "40px",
          backgroundColor: "rgba(50, 155, 216, 0.3)",
          fontSize: "20px",
          padding: "10px",
          width: "fit-content",
          borderRadius: "10px",
        }}
      >
        <p>
          Κόστος οικονομικότερης αλυσίδας {minValueCost} (αλυσίδα{" "}
          {minIndexCost + 1}).
        </p>
        <p>
          {" "}
          Λεπτά γρηγορότερης αλυσίδας {minValueTime} (αλυσίδα {minIndexTime + 1}
          ) .
        </p>
        <p>
          Ελάχιστο Περιβαλλοντικό Κόστος {minValueEnv} (αλυσίδα{" "}
          {minIndexEnv + 1}).
        </p>

        <button onClick={handleReload} style={{ fontSize: "16px" }}>
          Επανεκκίνηση διαδικασίας
        </button>
      </div>
    );
  };

  const renderChains = () => {
    if (!showchains) {
      return null;
    }

    if (value === "") {
      return <div>Please enter a positive integer</div>;
    }

    const count = parseInt(value, 10);
    if (isNaN(count) || count <= 0) {
      return <div>Please enter a positive integer</div>;
    }

    const chainsComponents = [];
    for (let i = 0; i < count; i++) {
      chainsComponents.push(
        <Chain
          key={i}
          chainOrder={i + 1}
          onFinancialCostUpdate={handleFinancialCostUpdate}
          onTimeValueUpdate={handleTimeValueUpdate}
          onEnvCostUpdate={handleEnvCostUpdate}
        />
      );
    }

    return chainsComponents;
  };

  const handleReload = () => {
    window.location.reload(); // Reload the current page
  };

  return (
    <div style={{ margin: "50px" }}>
      {!remove && (
        <>
          <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="Εισάγετε τον αριθμό διαφορετικών αλυσίδων που θέλετε να συγκρίνετε."
            style={{ width: "600px" }}
          />
          <button onClick={handleButtonClick}>Εισαγωγή</button>
        </>
      )}
      {renderChains()} {/* Call the renderChains function */}
      {showchains && (
        <div>
          <button
            onClick={handleClearButtonClick}
            style={{ marginLeft: "50px" }}
          >
            Υπολογισμός βέλτιστης αλυσίδας
          </button>
        </div>
      )}
      {result}
    </div>
  );
}

export default OptimalRoute;
